import marked from "marked";

const Plugin = {};
Plugin.install = function(Vue /*, options*/) {
	//console.log(options);
	// 1. добавление глобального метода или свойства
	// Vue.myGlobalMethod = function () {
	//   // некоторая логика ...
	// }

	// 2. добавление глобального объекта
	// Vue.directive('my-directive', {
	//   bind (el, binding, vnode, oldVnode) {
	//     // некоторая логика ...
	//   }
	// })

	// 3. добавление опций компонентов
	// Vue.mixin({
	// 	created: function() {
	// 		console.log(this);
	// 	},
	// });

	// 4. добавление метода экземпляра
	Vue.prototype.$marked = marked;
};

export default Plugin;
